import { Box } from "@mui/joy";
import CustomTypography from "components/common/CustomTypography";

// 상태 칩 공용 스타일 — 완료(초록)/대기(주황)/중립(회색). 링크 승인·계약·체험 상태 등에서 통일해 쓴다.
// 색은 theme text.green/text.orange 와 동일 값 (theme.vars 는 CSS var 참조라 알파 배경을 만들 수 없어 hex 로 고정).
const CHIP_STYLE = {
  positive: { color: "#349434", backgroundColor: "rgba(52, 148, 52, 0.12)" },
  pending: { color: "#CC7611", backgroundColor: "rgba(204, 118, 17, 0.12)" },
  neutral: { color: "#6B7280", backgroundColor: "rgba(107, 114, 128, 0.12)" },
};

export function StatusChip({
  positive,
  neutral,
  label,
  onClick,
}: {
  positive?: boolean;
  // 중립(회색) 칩 — 종료 등 성공/경고 어느 쪽도 아닌 상태. true 면 positive 를 무시한다.
  neutral?: boolean;
  label: string;
  onClick?: () => void;
}) {
  const style = neutral
    ? CHIP_STYLE.neutral
    : positive
      ? CHIP_STYLE.positive
      : CHIP_STYLE.pending;
  return (
    <Box
      onClick={onClick}
      sx={{
        flexShrink: 0,
        px: "8px",
        py: "2px",
        borderRadius: "999px",
        backgroundColor: style.backgroundColor,
        ...(onClick && { cursor: "pointer" }),
      }}
    >
      <CustomTypography
        variant="Footnote"
        sx={{ fontWeight: 700, color: style.color }}
      >
        {label}
      </CustomTypography>
    </Box>
  );
}

// 링크 승인 상태 칩 — 홈·프로필 정보 공용.
export default function CodeStatusChip({ isActive }: { isActive: boolean }) {
  return (
    <StatusChip
      positive={isActive}
      label={isActive ? "승인 완료" : "승인 대기"}
    />
  );
}
